import styled from '@emotion/styled';
import type { SingleFileInputProps } from '@zelos/shared/lib/file-input-hoc';
import { asSingleFileInput } from '@zelos/shared/lib/file-input-hoc';
import Image from 'next/image';
import Button from './Button';
import {
  EndWrapDiv,
  ErrorWrapDiv,
  StartWrapDiv,
} from './Input';
import { colors } from '@/constants/colors';
import icClearLight from '@/public/images/ic-clear-light.svg';
import icNotice from '@/public/images/ic-notice.svg';
import imgAttachmentFile from '@/public/images/img-attachment-file.svg';

type AdditionalProps = {
  buttonType?: 'outline' | 'grey',
};

const SingleFileInputWrapDiv = styled.div`
width: 100%;
`;

const SingleFileInputDiv = styled.div`
display: flex;
align-items: center;
gap: 8px;
`;

const FileInputButton = styled(Button)`
width: 100%;
max-width: 103px;
height: 46px;
`;

const FileNameBoxDiv = styled.div<{ disabled?: boolean }>`
position: relative;
width: 100%;
max-width: 422px;
height: 48px;
padding: 12px 40px 12px 20px;
border: 1px solid ${colors.grey100};
background: ${({ disabled }) => disabled ? colors.black10 : colors.white};
border-radius: 5px;
color: ${colors.black300};
font-size: 14px;
font-weight: 400;
line-height: 24px;
`;

const FileName = styled.span<{ hasFile?: boolean, pointer?: boolean, disabled?: boolean }>`
display: block;
overflow: hidden;
padding-left: ${({ hasFile }) => hasFile ? '20px' : '0'};
color: ${({ hasFile, disabled }) => hasFile && !disabled && colors.textPrimary};
cursor: ${({ pointer }) => pointer ? 'pointer' : 'inherit'};
line-height: 22px;
text-overflow: ellipsis;
white-space: nowrap;
`;

const CursorEndWrapDiv = styled(EndWrapDiv)<{ disabled?: boolean }>`
  z-index: 1;
  cursor: ${({ disabled }) => disabled ? 'inherit' : 'pointer'};
`;

const SingleFileInput = ({
  fileName,
  clearFile,
  downloadFileInServer,
  error,
  fileInServerInUse,
  inputId,
  buttonType,
  disabled,
}: SingleFileInputProps & AdditionalProps) => (
  <SingleFileInputWrapDiv>
    <SingleFileInputDiv>
      <FileNameBoxDiv
        disabled={disabled}
      >
        {fileName && (
          <StartWrapDiv>
            <Image src={imgAttachmentFile} alt="attachment file" />
          </StartWrapDiv>
        )}
        <FileName
          hasFile={!!fileName}
          disabled={disabled}
          pointer={fileInServerInUse}
          onClick={() => downloadFileInServer()}
        >{fileName || '파일을 첨부하세요'}
        </FileName>
        {fileName && (
          <CursorEndWrapDiv disabled={disabled} onClick={() => !disabled && clearFile()}>
            <Image src={icClearLight} alt="clear" />
          </CursorEndWrapDiv>
        )}
      </FileNameBoxDiv>
      <FileInputButton
        as="label"
        htmlFor={inputId}
        disabled={disabled}
        styleType={buttonType || 'grey'}
      >파일 첨부
      </FileInputButton>
    </SingleFileInputDiv>
    {error && (
      <ErrorWrapDiv>
        <Image src={icNotice} alt="notice" />
        <span>{error}</span>
      </ErrorWrapDiv>
    )}
  </SingleFileInputWrapDiv>
);

export default asSingleFileInput<AdditionalProps>(SingleFileInput);
